import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { t } from '../../../../modules/infra/i18n';

import ReportsFilter from '../reportsFilter';
import { updateAppointmentPlatformFilter } from '../actions';
import { getAppointmentPlatformFilters } from '../selectors';

const AppointmentPlatformFilter = ({ updatePlatformFilter, appointmentPlatformFilters, currentView }) => (
  <div className="c-form-input-group__item">
    <div className={cx('c-label', { 'u-ml--': currentView !== 'list' })}>
      {t('reports:appointment_platform_filter.filter_by_platform_label')}
    </div>
    <ReportsFilter
      title={t('reports:appointment_platform_filter.platform_title')}
      currentView={currentView}
      filters={appointmentPlatformFilters}
      updateStatusViewed={updatePlatformFilter}
      automationIdPart="appointmentPlatform"
    />
  </div>
);

AppointmentPlatformFilter.propTypes = {
  currentView: PropTypes.string,
  updatePlatformFilter: PropTypes.func.isRequired,
  appointmentPlatformFilters: PropTypes.array.isRequired,
};

AppointmentPlatformFilter.defaultProps = {
  currentView: '',
};

const mapStateToProps = state => ({
  appointmentPlatformFilters: getAppointmentPlatformFilters(state),
});

const mapDispatchToProps = {
  updatePlatformFilter: updateAppointmentPlatformFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentPlatformFilter);
